import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const RULE_SECTIONS = [
  {
    key: 'ai_rules',
    title: 'Reglas generales',
    description: 'Conocimiento de la casa que la IA respeta al sugerir equipo de depósito en cotizaciones.',
    placeholder:
      'Ej.:\n' +
      'Cuando pidan pantalla LED siempre incluir 1 procesador de video.\n' +
      'El kit de conferencia lleva consola + 2 micrófonos inalámbricos + sistema de PA.\n' +
      'Nunca sugerir equipos de la categoría "Decoración" para pedidos de audio.',
  },
  {
    key: 'rrhh_ai_rules',
    title: 'RRHH · Gestión y plan semanal',
    description: 'Reglas para transformar asignaciones de Gestión en sugerencias revisables del plan semanal.',
    placeholder:
      'Ej.:\n' +
      'FUENTES: eventos, tareas, armados\n' +
      'FASES_DE_GESTION: armado, evento, desarmado\n' +
      'IGNORAR_PERSONAS: X, sin nombre\n' +
      'NOMBRE_TURNO: sector, lugar, evento\n' +
      'HORARIOS: usar_horario_por_fase\n' +
      'CONFLICTOS: marcar_conflicto\n' +
      'MATCH_PERSONAS: normalizar_nombre',
  },
];

export default function SettingsPage() {
  const [rules, setRules] = useState(() => Object.fromEntries(RULE_SECTIONS.map(section => [section.key, ''])));
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState('');
  const [savedKey, setSavedKey] = useState('');

  useEffect(() => {
    Promise.all(RULE_SECTIONS.map(section => api.get(`/settings/${section.key}`).catch(() => ({ data: { value: '' } }))))
      .then(responses => {
        setRules(Object.fromEntries(RULE_SECTIONS.map((section, index) => [section.key, responses[index]?.data?.value || ''])));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (key) => {
    setSavingKey(key);
    setSavedKey('');
    try {
      await api.put(`/settings/${key}`, { value: rules[key] || '' });
      setSavedKey(key);
      setTimeout(() => setSavedKey(''), 2500);
    } catch (e) {
      alert(e.response?.data?.error || 'Error al guardar');
    } finally {
      setSavingKey('');
    }
  };

  const updateRules = (key, value) => setRules(prev => ({ ...prev, [key]: value }));

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Reglas de IA</h1>
      </div>

      <div style={{ display: 'grid', gap: 16, maxWidth: 860 }}>
        {RULE_SECTIONS.map(section => (
          <div className="card" style={{ padding: 20 }} key={section.key}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5ba3bd" strokeWidth="2">
                <path d="M12 3l1.9 5.8a2 2 0 0 0 1.3 1.3L21 12l-5.8 1.9a2 2 0 0 0-1.3 1.3L12 21l-1.9-5.8a2 2 0 0 0-1.3-1.3L3 12l5.8-1.9a2 2 0 0 0 1.3-1.3L12 3z"/>
              </svg>
              <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>{section.title}</h3>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-dim)', margin: '0 0 14px', lineHeight: 1.5 }}>
              {section.description}
            </p>
            <textarea
              className="form-input"
              value={rules[section.key] || ''}
              onChange={e => updateRules(section.key, e.target.value)}
              disabled={loading}
              rows={section.key === 'rrhh_ai_rules' ? 10 : 8}
              spellCheck={false}
              placeholder={section.placeholder}
              style={{ resize: 'vertical', fontFamily: '"SFMono-Regular", Consolas, Menlo, monospace', fontSize: 13, lineHeight: 1.6 }}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12 }}>
              <button className="btn btn-primary" onClick={() => handleSave(section.key)} disabled={savingKey === section.key || loading}>
                {savingKey === section.key ? 'Guardando…' : 'Guardar reglas'}
              </button>
              {savedKey === section.key && <span style={{ fontSize: 13, color: '#22c55e', fontWeight: 600 }}>✓ Guardado</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
